export enum SETTINGS_PROFILE_LABELS {
  MY_PROFILE = 'My Profile',
  PROFILE_PHOTO = 'Profile photo',
  USER_DETAILS = 'User details',
  FIRST_NAME = 'First Name',
  LAST_NAME = 'Last Name',
  EMAIL = 'Email',
  MAILING_LINE1 = 'Address line 1',
  MAILING_LINE2 = 'Address line 2',
  ZIP_CODE = 'Zip Code',
  CITY = 'City',
  PHONE = 'Mobile Phone',
  COUNTRY = 'Country',
  SPECIALITY = 'Specialty',
  MEDICAL_LICENSE = 'Medical license',
  MEDICAL_LICENSE_NUMBER = 'Medical license number',
  DEA_LICENSE = 'DEA license',
  DEA_LICENSE_NUMBER = 'DEA license number',
  ADDITIONAL_LICENSE = 'Additional license',
  STATE = 'State',
  CHANGE_PASSWORD = 'Change password',
  CURRENT_PASSWORD = 'Current password',
  NEW_PASSWORD = 'New password',
  CONFIRM_PASSWORD = 'Confirm password',
  BOOKING_NOTIFICATIONS = 'Booking',
  PROFESSIONAL_DETAILS = 'Professional details',
  RELATED_NOTIFICATIONS = 'Booking related notifications',
  STATUS_NOTIFICATIONS = 'Support ticket notifications',
  REMOVE_IMAGE = 'Remove image',
  CONFIRM_DELETE_AVATAR = 'Are your sure you want to delete avatar image?',
  MAILING_ADDRESS = 'Mailing address',
  EMAIL_NOTIFICATIONS_LABEL = 'The following will be emailed to you:',
  SCHEDULE_NOTIFICATIONS = 'Schedule & Booking',
  SCHEDULE_NOTIFICATIONS_LABEL = 'The following will be texted to you (data rates may apply):',
  PATIENT_CONFIRMATION = 'Patient Confirmation',
  PATIENT_CANCELATION = 'Patient Cancelation',
  PATIENT_RESCHEDULE = 'Patient Reschedule',
  END_OF_BOOKING = 'End of Booking Notification',
  PATIENT_ON_SITE_TEXT_MESSAGES = 'Patient On-Site Text Messages',
  OFFICE_PHONE = 'Office Phone',
  SALUTATION = 'Salutation',
  QUALIFICATION = 'Qualification',
  ACCEPT_WALK_IN_PATIENT = 'Accept Walk-In Patients',
  ALLOW_SCRIBE = 'Allow Scribe',
  ACCEPT_EARLY_PATIENT_CHECK_IN = 'Accept Patient early/late Check-in',
  DISPLAY_NAME = 'Display Name',
  DEFAULT_APPOINTMENT_TIME = 'Default Appointment Time',
  PATIENT_CHECKIN = 'Patient Check-in',
  APPOINTMENT_COLOR = 'Appointment Color',
  CONFIRM_APPT_BEFORE = 'Send Cancellation Policy Reminder',
  CANCEL_POLICY_CHARGE_DAYS = 'Cancellation Policy Charge Days',
  RIGHT_AWAY_APPOINTMENT_REMINDER = 'Send Right Away Appointment Reminder',
  FIRST_APPOINTMENT_REMINDER_BEFORE = 'Send First Appointment Reminder Before Days',
  SEND_SMS_RECALL_BEFORE_APPOINTMENT = 'Send SMS Recall Before Appointment Days',
}
